// Agent configuration for BM-Assist
export const AGENTS = [
  { name: 'Joe B', email: 'joeb@bm-assist.co' },
  { name: 'Danny C', email: 'dannyc@bm-assist.co' },
  { name: 'Joe T', email: 'joet@bm-assist.co' },
  { name: 'Ariana M', email: 'arianam@bm-assist.co' },
  { name: 'Malik R', email: 'malikr@bm-assist.co' },
  { name: 'Sarah K', email: 'sarahk@bm-assist.co' },
  { name: 'Luis P', email: 'luisp@bm-assist.co' },
  { name: 'Chloe H', email: 'chloeh@bm-assist.co' }
];

// Helper to get agent email from name
export const getAgentEmail = (agentName) => {
  const agent = AGENTS.find(a => a.name === agentName);
  return agent ? agent.email : '';
};

// Helper to get agent name from email
export const getAgentName = (email) => {
  const agent = AGENTS.find(a => a.email === email);
  return agent ? agent.name : '';
};
